export const APP_IDS = Object.freeze({
  SHOPIFY: {
    QA: 1920453,
    PROD: 542084
  }
});
export const DEFAULT_APP_ID = 'SHOPIFY';
export const ECOMMERCE_OBJECT_TYPES = Object.freeze({
  STORE: 'STORE',
  DISCOUNT_CODE: 'DISCOUNT_CODE',
  ORDER: 'ORDER'
});
export const ECOMMERCE_OBJECT_TYPE_IDS = Object.freeze({
  DISCOUNT_CODE: '0-110',
  ORDER: '0-123'
});
export const ECOMMERCE_OBJECT_LABEL_PROPERTIES = Object.freeze({
  DISCOUNT_CODE: 'hs_discount_code',
  ORDER: 'hs_order_name'
});